import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Plantilla } from './plantillas.model';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';

// services
import { EventService } from 'src/app/core/service/event.service';
import { PlantillaService } from './plantillas.service';

// constants
import { EventType } from 'src/app/core/constants/events';
import { NgForm } from '@angular/forms';


@Component({
  selector: 'app-folders-plantilla',
  templateUrl: './folders-plantilla.component.html',
  styleUrls: ['./folders-plantilla.component.scss']
})
export class FoldersPlantillaComponent implements OnInit, AfterViewInit {

  constructor(
    private eventService: EventService,
    private plantillaService: PlantillaService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  // ID de la plantilla
  id!: string | null;

  plantilla!: Plantilla;

  ngOnInit(): void {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.id !== null) {
      this.plantillaService.getPlantilla(this.id).subscribe((res) => {
        this.plantilla = res;

        this.eventService.broadcast(EventType.CHANGE_PAGE_TITLE,
          {
            title: 'Editar carpetas: ' + this.plantilla.nombre,
            breadCrumbItems: [{ label: 'Plantillas', path: '.' }, { label: 'Editar carpetas', path: '.', active: true }]
          }
        );

      },
        (error: string) => {

        });
    }
  }

  ngAfterViewInit(): void {
   
  }

}
